import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=78461563"
import script from "./Distributor.vue?vue&type=script&lang=js"
export * from "./Distributor.vue?vue&type=script&lang=js"
import style0 from "./Distributor.vue?vue&type=style&index=0&id=78461563&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports